<template>
  <div>
    <BaseHeadline icon="mdi-view-dashboard">
      <template v-slot:headlineBtns>
        <v-scale-transition>
          <v-btn
            v-if="isResponsible && !isCompleted"
            class="mb-0 mr-2"
            color="primary"
            depressed
            @click="showChangeStatusDialog = true"
          >
            <v-icon left>mdi-checkbox-marked-circle-outline</v-icon>
            Sett som behandlet
          </v-btn>
        </v-scale-transition>
        <v-scale-transition>
          <v-btn
            v-if="isResponsible"
            color="primary"
            depressed
            @click="showChangeResponsiblyDialog = true"
          >
            <v-icon left>mdi-account-outline</v-icon>
            Endre ansvarllig
          </v-btn>
        </v-scale-transition>
      </template>
    </BaseHeadline>

    <v-alert
      v-show="isResponsible !== null && alertText"
      type="info"
      transition="fade-transition"
    >
      {{ alertText }}
    </v-alert>

    <v-alert
      class="mt-2"
      v-show="isResponsible && isResponsibleText && !isCompleted"
      type="info"
      transition="fade-transition"
    >
      {{ isResponsibleText }}
    </v-alert>

    <ButtonGroup
      class="my-3"
      v-if="$vuetify.breakpoint.smAndDown && isResponsible && !isCompleted"
      v-model="buttons"
      @changeResponsibly="showChangeResponsiblyDialog = true"
      @changeStatus="showChangeStatusDialog = true"
    />

    <BaseView v-model="list">
      <template v-slot="{ element }">
        <MeasureInfoCard
          v-if="element.type === 'MeasureInfoCard'"
          v-model="data"
          :loading="loading"
        />
        <!-- <MeasureFloorplanCard v-if="element.type === 'MeasureFloorplanCard'" /> -->
        <MeasureLocationCard
          v-if="element.type === 'MeasureLocationCard'"
          v-model="data"
          :loading="loading"
        />
        <MeasureUserCard
          v-if="
            element.type === 'MeasureUserCard' && data && data.currentCustomer
          "
          v-model="data"
          :loading="loading"
        />
        <Attachments
          v-if="element.type === 'Attachments' && data.attachments"
          v-model="data.attachments"
          @change="attachmentsAdded"
        ></Attachments>
        <Comments
          ref="comments"
          v-if="element.type === 'commentsCard'"
          :context="commentsType"
          :tagUsers="tagUsers"
          @comments="getComments"
        />
      </template>
    </BaseView>
    <ChangeResponsiblyDialog
      v-model="showChangeResponsiblyDialog"
      :responsible="data.responsible"
      @save="changeResponsible"
    />
    <!-- <ChangeStatusDialog v-model="showChangeStatusDialog" /> -->

    <ConfirmDialog
      v-model="showChangeStatusDialog"
      title="Bekreft"
      icon="mdi-checkbox-marked-circle-outline"
      text="Er du sikker på at du vil sette tiltak som behandlet?"
      btnActionName="Bekreft"
      @action="changeStatus"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import aberrationApi from "@/api/aberrationApi";
import { valueTypeObject } from "@/types/commentInterface";
import { CommentType } from "@/enums/enums";
import { mapGetters } from "vuex";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import ButtonGroup from "@/components/shared/buttons/ButtonGroup.vue";
import BaseView from "@/components/shared/BaseView.vue";
import MeasureInfoCard from "@/components/measures/measure/MeasureInfoCard.vue";
// import MeasureFloorplanCard from "@/components/measures/measure/MeasureFloorplanCard.vue";
import MeasureLocationCard from "@/components/measures/measure/MeasureLocationCard.vue";
import MeasureUserCard from "@/components/measures/measure/MeasureUserCard.vue";
import ChangeResponsiblyDialog from "@/components/shared/dialog/ChangeResponsiblyDialog.vue";
// import ChangeStatusDialog from "@/components/shared/dialog/ChangeStatusDialog.vue";
import Comments from "@/components/shared/comments/Commens.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";
import Attachments from "@/components/shared/attachments/Attachments.vue";
import { KeyValueExtra } from "@/types/keyValue";

export default Vue.extend({
  data() {
    return {
      data: {} as any,
      loading: false,
      showChangeResponsiblyDialog: false,
      showChangeStatusDialog: false,
      tagUsers: [] as Array<KeyValueExtra>,
      commentsType: {} as valueTypeObject,
      comments: null as any,
      list: {
        lg: [
          [{ type: "MeasureInfoCard" }],
          // [{ type: "MeasureFloorplanCard" }],
          [{ type: "MeasureLocationCard" }, { type: "MeasureUserCard" }],
          [{ type: "Attachments" }, { type: "commentsCard" }],
        ],
        md: [
          [
            { type: "MeasureInfoCard" },
            { type: "MeasureLocationCard" },
            { type: "MeasureUserCard" },
          ],
          [
            // { type: "MeasureFloorplanCard" },
            { type: "Attachments" },
            { type: "commentsCard" },
          ],
        ],
        sm: [
          [
            { type: "MeasureInfoCard" },
            // { type: "MeasureFloorplanCard" },
            { type: "MeasureLocationCard" },
            { type: "MeasureUserCard" },
            { type: "Attachments" },
            { type: "commentsCard" },
          ],
        ],
      },
      buttons: [
        {
          show: true,
          name: "Sett behandlet",
          color: "primary",
          emit: "changeStatus",
          icon: "mdi-checkbox-marked-circle-outline",
        },
        {
          show: true,
          name: "Endre ansvarlig",
          color: "primary",
          emit: "changeResponsibly",
          icon: "mdi-account-outline",
        },
      ],
    };
  },

  async mounted() {
    this.loading = true;
    var id = parseInt(this.$route.params.id);
    await aberrationApi.getActionsDetails(id).then((response) => {
      this.data = response.action;

      this.loading = false;

      this.commentsType.id = response.action.id;
      this.commentsType.commentType = CommentType.Action;
      this.commentsType.commentStatus = response.action.actionStatus;
      this.tagUsers = response.tagUsers;

      (this as any).$refs.comments.getComments(this.commentsType);
    });
  },
  methods: {
    getComments(comments) {
      this.comments = comments;
    },
    async save(data) {
      await aberrationApi
        .saveAction(data)
        .then((response) => {
          this.data = response;
          (this as any).$refs.comments.getComments(this.commentsType);
          this.showChangeStatusDialog = false;
        })
        .catch(() => {
          this.showChangeStatusDialog = false;
        });
    },
    async changeStatus() {
      //Set status to behandlet
      var data = { ...this.data };
      data.actionStatus = 3;
      await this.save(data);
    },
    async attachmentsAdded() {
      await this.save(this.data);
    },
    async changeResponsible(newResponsibleId) {
      this.data.responsibleId = newResponsibleId;
      await this.save(this.data);
      this.showChangeResponsiblyDialog = false;
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
    }),
    isResponsible(): boolean | null {
      if (
        (!this.isTrysilhus && this.isMainContactPerson) ||
        this.data?.responsibleId === this.profile.id
      ) {
        return true;
      }
      return null;
    },
    isCompleted(): boolean | null {
      if (this.data?.actionStatus) {
        return this.data.actionStatus === 3;
      }
      return null;
    },
    alertText(): string {
      if (this.isTrysilhus && this.isResponsible === false) {
        return "Kun ansvarlig kan endre ansvarlig og sette tiltak som behandlet!";
      } else if (!this.isTrysilhus && this.isResponsible === false) {
        if (this.isMainContactPerson) {
          return "Kun ansvarlig kan sette tiltak som behandlet!";
        } else {
          return "Hovedkontaktperson og ansvarlig kan endre ansvarlig, men kun ansavarlig kan sette tiltak som behandlet!";
        }
      }

      return "";
    },
    isResponsibleText(): string {
      //Is high
      if (this.data?.severity === 1) {
        //No attachments and no commetns
        if (
          this.data?.attachments.length === 0 &&
          this.comments?.length === 0
        ) {
          return "Må legge til vedlegg og kommentar for å kunne sette tiltak som behandlet!";
        }
        //No attachments
        else if (this.data?.attachments.length === 0) {
          return "Må legge til vedlegg for å kunne sette tiltak som behandlet!";
        }
        //No comments
        else if (this.comments?.length === 0) {
          return "Må legge til kommentar for å kunne sette tiltak som behandlet!";
        }
        return "";
      }
      //Is low and no commetns
      else if (this.data && this.comments?.length === 0) {
        return "Må legge til kommentar for å kunne sette tiltak som behandlet!";
      }
      return "";
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    ButtonGroup,
    MeasureInfoCard,
    // MeasureFloorplanCard,
    MeasureLocationCard,
    MeasureUserCard,
    ChangeResponsiblyDialog,
    // ChangeStatusDialog,
    Comments,
    ConfirmDialog,
    Attachments,
  },
});
</script>
